'use strict'

export const StatusIndicator = {
  props: {
    widthRange: 'Z+V',
    theme: 'primary',
    round: '100%',
    aspectRatio: '1/1',
    border: 'solid, gray',
    borderWidth: '2px'
  }
}
